<script lang="ts">
    import { JourneyNodeData } from '@journeys/Journeys.viewmodel';
    import { loadTags, createTag } from '@shared/components/Tags/Tags.access';
    import { type Tag } from '@shared/components/Tags/TagsTypes';

    const component = {
        name: 'Partial_TagNodeSettings',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    import { ref, onMounted } from 'vue';
    import MultiSelect from '@shared/components/MultiSelect/MultiSelect.vue';

    const props = defineProps<{
        data: JourneyNodeData;
        id: number;
    }>();

    const tags = ref<Tag[]>([]);

    onMounted(async () => {
        tags.value = await loadTags();

        if (!props.data.TagIdsToAdd) props.data.TagIdsToAdd = [];
        if (!props.data.TagIdsToRemove) props.data.TagIdsToRemove = [];
    });

    // The "add" multi-select allows users to select tags that
    // are to be added to the contact when they get to this stage in the journey.
    // This function is for the functionality where you can "save new" tags directly from
    // the multi-select.
    const handleNewTagToAdd = async (name: string) => {
        const newTag = await createTag(name.trim());
        tags.value = [...tags.value, newTag];
        props.data.TagIdsToAdd = [...(props.data.TagIdsToAdd ?? []), newTag.TagId];
    };

    // The same as the "add" version, but for the list of "to remove" tags where things are removed.
    const handleNewTagToRemove = async (name: string) => {
        const newTag = await createTag(name.trim());
        tags.value = [...tags.value, newTag];
        props.data.TagIdsToRemove = [...(props.data.TagIdsToRemove ?? []), newTag.TagId];
    };
</script>

<template>
    <MultiSelect
        class="form-group"
        :items="tags"
        :selectedItems="data.TagIdsToAdd ?? []"
        displayProp="Title"
        selectProp="TagId"
        selectOnly="TagId"
        :label="$Resources.JourneyTagNodeAddTagsLabel"
        @update:selectedItems="(val) => (data.TagIdsToAdd = val)"
        @newItem="handleNewTagToAdd" />

    <MultiSelect
        class="form-group"
        :items="tags"
        :selectedItems="data.TagIdsToRemove ?? []"
        displayProp="Title"
        selectProp="TagId"
        selectOnly="TagId"
        :label="$Resources.JourneyTagNodeRemoveTagsLabel"
        @update:selectedItems="(val) => (data.TagIdsToRemove = val)"
        @newItem="handleNewTagToRemove" />
</template>
